<template>

    <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="1280" persistent
        scrollable>
        <v-card class="pa-0" style="height: 92vh; border-radius: 12px; overflow: hidden; background-color: #fff;">
            <!-- Header Title -->
            <div class="px-6 pt-6 pb-2 " style="box-shadow: 0px 2px 12px rgba(102, 102, 102, 0.12);">

                <div class="d-flex justify-space-between align-center">
                    <h2 class="text-h6 font-weight-bold" style="margin: 0;">Design Your Form</h2>

                    <v-icon @click="$emit('update:dialog', false)" class="cursor-pointer">mdi-close</v-icon>

                </div>
                <!-- Tabs -->
                <div class="d-flex align-center mt-3 tab-header">
                    <div v-for="tab in tabs" :key="tab.value" class="tab-button d-flex align-center" :class="[
                        { active: activeTab === tab.value },
                        activeTabClass(tab.value)
                    ]" @click="activeTab = tab.value">
                        <span class="tab-icon mr-2">
                            <img v-if="tab.image" :src="tab.image" alt="icon" width="23" height="23" />
                            <v-icon v-else :icon="tab.icon" size="23" />
                        </span>
                        <span class="tab-label">{{ tab.label }}</span>
                    </div>
                </div>
            </div>

            <!-- Main Body -->
            <div class="d-flex" style="height: calc(100% - 120px)">
                <!-- Sidebar -->
                <div class="sidebar">
                    <div v-for="(step, index) in steps" :key="index" class="sidebar-item"
                        :class="{ active: currentStep === index }" @click="currentStep = index">
                        {{ step }}
                    </div>
                </div>

                <!-- Dynamic Content -->
                <div class="flex-grow-1 px-6 py-4 overflow-y-auto custom-height">
                    <component :is="currentComponent" :platform="activeTab" :key="activeTab + '-' + currentStep"
                        ref="currentStepRef" />
                </div>

                <!-- Right Empty Column -->
                <div style="width: 220px; background: #f5f7fa;"></div>
            </div>

            <!-- Footer -->
            <v-card-actions class="justify-end px-6 py-4 border-top">
                <v-btn class="text-white back-btn mr-3" v-if="currentStep > 0" rounded @click="goBack">back</v-btn>
                <v-btn class="text-white next-btn" v-if="currentStep < steps.length - 1" rounded
                    @click="goNext">Next</v-btn>
                <v-btn class="text-white next-btn" v-if="currentStep === steps.length - 1" rounded
                    @click="submitForm">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import FormDetailsStep from '@/components/SuperApp/Awareness/LeedForm/Meta/FormDetailsStep.vue';
import QuestionsStep from '@/components/SuperApp/Awareness/LeedForm/Meta/QuestionsStep.vue';
import DisclosuresStep from '@/components/SuperApp/Awareness/LeedForm/Meta/DisclosuresStep.vue';
import EndingStep from '@/components/SuperApp/Awareness/LeedForm/Meta/EndingStep.vue';
import { nextTick } from 'vue';
import { useSuperLeedForm } from '@/store/SuperLeedForm';
import { useGeneralStore } from '@/store/General';

import { defineAsyncComponent } from 'vue';
export default {
    name: 'LeadFormDialog',
    components: {
        FormDetailsStep,
        QuestionsStep,
        DisclosuresStep,
        EndingStep,
    },

    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:dialog'],

    data() {
        return {

            activeTab: 'meta',
            currentStep: 0,
            tabs: [],
            store: useSuperLeedForm(),
            gstore: useGeneralStore(),
        };
    },
    computed: {
        steps() {
            if (this.activeTab === 'tiktok') {
                return ['Form Details'];
            }

            return ['Form Details', 'Questions', 'Disclosures', 'Ending'];
        },
        currentComponent() {
            const stepName = this.steps[this.currentStep].replace(/\s+/g, '');
            const platform = this.activeTab;

            const componentsMap = {
                meta: {
                    FormDetailsStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Meta/FormDetailsStep.vue')),
                    QuestionsStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Meta/QuestionsStep.vue')),
                    DisclosuresStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Meta/DisclosuresStep.vue')),
                    EndingStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Meta/EndingStep.vue')),
                },
                snapchat: {
                    FormDetailsStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Snap/FormDetailsStep.vue')),
                    QuestionsStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Snap/QuestionsStep.vue')),
                    DisclosuresStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Snap/DisclosuresStep.vue')),
                    EndingStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Snap/EndingStep.vue')),
                },
                tiktok: {
                    FormDetailsStep: defineAsyncComponent(() => import('@/components/SuperApp/Awareness/LeedForm/Tiktok/FormDetailsStep.vue')),
                }

            };

            const key = stepName + 'Step';
            return componentsMap[platform][key];
        }
    },
    methods: {
        async submitForm() {
            try {
                this.gstore.ShowLoading();
                await nextTick();

                const stepRef = this.$refs.currentStepRef;

                if (stepRef?.validate && typeof stepRef.validate === 'function') {
                    const isValid = await stepRef.validate();
                    if (!isValid) return;
                }
                if (this.activeTab === 'meta') {
                    await this.store.sendmeta();
                } else {
                    await this.store.sendsnap();
                }

                this.gstore.showSnackbar("Form created successfully ✅", "#066f63");
            } catch (err) {
                this.gstore.showSnackbar(err.response.data.msg, "#BB2124");
            }
            finally {
                this.gstore.HideLoading()
            }
        }
        ,
        activeTabClass(tabValue) {
            if (this.activeTab !== tabValue) return '';

            switch (tabValue) {
                case 'snapchat':
                    return 'tab-yellow';
                case 'tiktok':
                    return 'tab-black';
                case 'meta':
                    return 'tab-blue';
                default:
                    return '';
            }
        },
        async goNext() {
            await nextTick();

            const stepRef = this.$refs.currentStepRef;

            if (stepRef?.validate && typeof stepRef.validate === 'function') {
                const isValid = await stepRef.validate();
                if (!isValid) return;
            }

            if (this.currentStep < this.steps.length - 1) {
                this.currentStep++;
            }
        },
        goBack() {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
        },
    },
    mounted() {
        const storedPlatforms = localStorage.getItem("super_selected_platforms");
        if (storedPlatforms) {
            try {
                const parsed = JSON.parse(storedPlatforms);

                const desiredOrder = ['meta', 'snapchat', 'tiktok'];

                const normalizedTabs = parsed.map((platform) => ({
                    label: platform.name,
                    value: platform.name.toLowerCase(),
                    image: platform.icon || null,
                }));

                this.tabs = desiredOrder
                    .map(key => normalizedTabs.find(tab => tab.value === key))
                    .filter(Boolean);
            } catch (e) {
                console.error("Failed to parse platforms:", e);
            }
        }
    }
    ,
    watch: {
        tabs: {
            immediate: true,
            handler(newTabs) {
                if (newTabs.length > 0 && !this.activeTab) {
                    this.activeTab = newTabs[0].value;
                }
            },
        },
        activeTab() {
            this.currentStep = 0;
        }
    },

};
</script>

<style scoped>
.tab-yellow {
    color: #000 !important;
    border-bottom: 2px solid rgb(247, 217, 1) !important;
}

.tab-black {
    color: #000 !important;
    border-bottom: 2px solid #0D0D0D !important;
}

.tab-blue {
    color: #000 !important;
    border-bottom: 2px solid #0067E3 !important;
}

.border-top {
    box-shadow: 0px 2px 12px rgba(102, 102, 102, 0.12);
}

.tab-header {
    gap: 20px;
}

.tab-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #888;
    border-bottom: 2px solid transparent;
}

.tab-button.active {
    color: #000;
}

.sidebar {
    width: 200px;
    background: #f8f9fa;
    padding: 24px 16px;
    border-right: 1px solid #eee;
}

.sidebar-item {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    margin-bottom: 8px;
    color: #333;
    transition: all 0.2s;
}

.sidebar-item.active {
    background: #e0f3ef;
    color: #066f63;
    font-weight: 600;
}

.next-btn {
    background-color: #066f63;
    caret-color: rgb(6, 111, 99);
    padding: 0.3rem 2rem;
    border-radius: 0.4rem;
}

.back-btn {
    background-color: #F2F2F2;
    color: #4D4D4D !important;
    padding: 0.3rem 2rem;
    border-radius: 0.4rem;
}

.dynamic-height {
    max-height: 60vh;
}

.custom-height {
    min-height: 70vh;
    max-height: 70vh;
}
</style>
